'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncGeneratorDelegate = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var errCode = require('err-code');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var globalThis = require('ipfs-utils/src/globalthis');
/*
 * Transform one of:
 *
 * ```
 * Bytes (Buffer|ArrayBuffer|TypedArray) [single file]
 * Bloby (Blob|File) [single file]
 * String [single file]
 * { path, content: Bytes } [single file]
 * { path, content: Bloby } [single file]
 * { path, content: String } [single file]
 * { path, content: Iterable<Number> } [single file]
 * { path, content: Iterable<Bytes> } [single file]
 * { path, content: AsyncIterable<Bytes> } [single file]
 * Iterable<Number> [single file]
 * Iterable<Bytes> [single file]
 * Iterable<Bloby> [multiple files]
 * Iterable<String> [multiple files]
 * Iterable<{ path, content: Bytes }> [multiple files]
 * Iterable<{ path, content: Bloby }> [multiple files]
 * Iterable<{ path, content: String }> [multiple files]
 * Iterable<{ path, content: Iterable<Number> }> [multiple files]
 * Iterable<{ path, content: Iterable<Bytes> }> [multiple files]
 * Iterable<{ path, content: AsyncIterable<Bytes> }> [multiple files]
 * AsyncIterable<Bytes> [single file]
 * AsyncIterable<Bloby> [multiple files]
 * AsyncIterable<String> [multiple files]
 * AsyncIterable<{ path, content: Bytes }> [multiple files]
 * AsyncIterable<{ path, content: Bloby }> [multiple files]
 * AsyncIterable<{ path, content: String }> [multiple files]
 * AsyncIterable<{ path, content: Iterable<Number> }> [multiple files]
 * AsyncIterable<{ path, content: Iterable<Bytes> }> [multiple files]
 * AsyncIterable<{ path, content: AsyncIterable<Bytes> }> [multiple files]
 * ```
 * Into:
 *
 * ```
 * AsyncIterable<{ path, content: AsyncIterable<Buffer> }>
 * ```
 *
 * @param input Object
 * @return AsyncInterable<{ path, content: AsyncIterable<Buffer> }>
 */


module.exports = function normaliseInput(input) {
  // must give us something
  if (input === null || input === undefined) {
    throw errCode(new Error("Unexpected input: ".concat(input), 'ERR_UNEXPECTED_INPUT'));
  } // String


  if (typeof input === 'string' || input instanceof String) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return toFileObject(input);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  } // Buffer|ArrayBuffer|TypedArray
  // Blob|File


  if (isBytes(input) || isBloby(input)) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return toFileObject(input);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  } // Iterable<?>


  if (input[Symbol.iterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var iterator, first, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, obj;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // eslint-disable-line require-await
              iterator = input[Symbol.iterator]();
              first = iterator.next();

              if (!first.done) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", iterator);

            case 4:
              if (!(Number.isInteger(first.value) || isBytes(first.value))) {
                _context4.next = 8;
                break;
              }

              _context4.next = 7;
              return toFileObject(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return first.value;

                      case 2:
                        return _context3.delegateYield(iterator, "t0", 3);

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })());

            case 7:
              return _context4.abrupt("return");

            case 8:
              if (!(isFileObject(first.value) || isBloby(first.value) || typeof first.value === 'string')) {
                _context4.next = 38;
                break;
              }

              _context4.next = 11;
              return toFileObject(first.value);

            case 11:
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context4.prev = 14;
              _iterator4 = iterator[Symbol.iterator]();

            case 16:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context4.next = 23;
                break;
              }

              obj = _step4.value;
              _context4.next = 20;
              return toFileObject(obj);

            case 20:
              _iteratorNormalCompletion4 = true;
              _context4.next = 16;
              break;

            case 23:
              _context4.next = 29;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](14);
              _didIteratorError4 = true;
              _iteratorError4 = _context4.t0;

            case 29:
              _context4.prev = 29;
              _context4.prev = 30;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 32:
              _context4.prev = 32;

              if (!_didIteratorError4) {
                _context4.next = 35;
                break;
              }

              throw _iteratorError4;

            case 35:
              return _context4.finish(32);

            case 36:
              return _context4.finish(29);

            case 37:
              return _context4.abrupt("return");

            case 38:
              throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

            case 39:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[14, 25, 29, 37], [30,, 32, 36]]);
    }))();
  } // window.ReadableStream


  if (typeof input.getReader === 'function') {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, obj;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context5.prev = 2;
              _iterator = _asyncIterator(browserStreamToIt(input));

            case 4:
              _context5.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context5.sent;
              _iteratorNormalCompletion = _step.done;
              _context5.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context5.sent;

              if (_iteratorNormalCompletion) {
                _context5.next = 18;
                break;
              }

              obj = _value;
              _context5.next = 15;
              return toFileObject(obj);

            case 15:
              _iteratorNormalCompletion = true;
              _context5.next = 4;
              break;

            case 18:
              _context5.next = 24;
              break;

            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context5.t0;

            case 24:
              _context5.prev = 24;
              _context5.prev = 25;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context5.next = 29;
                break;
              }

              _context5.next = 29;
              return _awaitAsyncGenerator(_iterator.return());

            case 29:
              _context5.prev = 29;

              if (!_didIteratorError) {
                _context5.next = 32;
                break;
              }

              throw _iteratorError;

            case 32:
              return _context5.finish(29);

            case 33:
              return _context5.finish(24);

            case 34:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 20, 24, 34], [25,, 29, 33]]);
    }))();
  } // AsyncIterable<?>


  if (input[Symbol.asyncIterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      var iterator, first, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, obj;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              iterator = input[Symbol.asyncIterator]();
              _context7.next = 3;
              return _awaitAsyncGenerator(iterator.next());

            case 3:
              first = _context7.sent;

              if (!first.done) {
                _context7.next = 6;
                break;
              }

              return _context7.abrupt("return", iterator);

            case 6:
              if (!isBytes(first.value)) {
                _context7.next = 10;
                break;
              }

              _context7.next = 9;
              return toFileObject(_wrapAsyncGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee6() {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return first.value;

                      case 2:
                        return _context6.delegateYield(_asyncGeneratorDelegate(_asyncIterator(iterator), _awaitAsyncGenerator), "t0", 3);

                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }))());

            case 9:
              return _context7.abrupt("return");

            case 10:
              if (!(isFileObject(first.value) || isBloby(first.value) || typeof first.value === 'string')) {
                _context7.next = 48;
                break;
              }

              _context7.next = 13;
              return toFileObject(first.value);

            case 13:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context7.prev = 15;
              _iterator2 = _asyncIterator(iterator);

            case 17:
              _context7.next = 19;
              return _awaitAsyncGenerator(_iterator2.next());

            case 19:
              _step2 = _context7.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context7.next = 23;
              return _awaitAsyncGenerator(_step2.value);

            case 23:
              _value2 = _context7.sent;

              if (_iteratorNormalCompletion2) {
                _context7.next = 31;
                break;
              }

              obj = _value2;
              _context7.next = 28;
              return toFileObject(obj);

            case 28:
              _iteratorNormalCompletion2 = true;
              _context7.next = 17;
              break;

            case 31:
              _context7.next = 37;
              break;

            case 33:
              _context7.prev = 33;
              _context7.t0 = _context7["catch"](15);
              _didIteratorError2 = true;
              _iteratorError2 = _context7.t0;

            case 37:
              _context7.prev = 37;
              _context7.prev = 38;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context7.next = 42;
                break;
              }

              _context7.next = 42;
              return _awaitAsyncGenerator(_iterator2.return());

            case 42:
              _context7.prev = 42;

              if (!_didIteratorError2) {
                _context7.next = 45;
                break;
              }

              throw _iteratorError2;

            case 45:
              return _context7.finish(42);

            case 46:
              return _context7.finish(37);

            case 47:
              return _context7.abrupt("return");

            case 48:
              throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

            case 49:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[15, 33, 37, 47], [38,, 42, 46]]);
    }))();
  } // { path, content: ? }
  // Note: Detected _after_ AsyncIterable<?> because Node.js streams have a
  // `path` property that passes this check.


  if (isFileObject(input)) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return toFileObject(input);

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }

  throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');
};

function toFileObject(input) {
  var obj = {
    path: input.path || '',
    mode: input.mode,
    mtime: input.mtime
  };

  if (input.content) {
    obj.content = toAsyncIterable(input.content);
  } else if (!input.path) {
    // Not already a file object with path or content prop
    obj.content = toAsyncIterable(input);
  }

  return obj;
}

function toAsyncIterable(input) {
  // Bytes | String
  if (isBytes(input) || typeof input === 'string') {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return toBuffer(input);

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  } // Bloby


  if (isBloby(input)) {
    return blobToAsyncGenerator(input);
  } // Browser stream


  if (typeof input.getReader === 'function') {
    return browserStreamToIt(input);
  } // Iterator<?>


  if (input[Symbol.iterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11() {
      var iterator, first, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, chunk;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              // eslint-disable-line require-await
              iterator = input[Symbol.iterator]();
              first = iterator.next();

              if (!first.done) {
                _context11.next = 4;
                break;
              }

              return _context11.abrupt("return", iterator);

            case 4:
              if (!Number.isInteger(first.value)) {
                _context11.next = 8;
                break;
              }

              _context11.next = 7;
              return toBuffer(Array.from(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee10() {
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return first.value;

                      case 2:
                        return _context10.delegateYield(iterator, "t0", 3);

                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              })()));

            case 7:
              return _context11.abrupt("return");

            case 8:
              if (!isBytes(first.value)) {
                _context11.next = 38;
                break;
              }

              _context11.next = 11;
              return toBuffer(first.value);

            case 11:
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context11.prev = 14;
              _iterator5 = iterator[Symbol.iterator]();

            case 16:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context11.next = 23;
                break;
              }

              chunk = _step5.value;
              _context11.next = 20;
              return toBuffer(chunk);

            case 20:
              _iteratorNormalCompletion5 = true;
              _context11.next = 16;
              break;

            case 23:
              _context11.next = 29;
              break;

            case 25:
              _context11.prev = 25;
              _context11.t0 = _context11["catch"](14);
              _didIteratorError5 = true;
              _iteratorError5 = _context11.t0;

            case 29:
              _context11.prev = 29;
              _context11.prev = 30;

              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }

            case 32:
              _context11.prev = 32;

              if (!_didIteratorError5) {
                _context11.next = 35;
                break;
              }

              throw _iteratorError5;

            case 35:
              return _context11.finish(32);

            case 36:
              return _context11.finish(29);

            case 37:
              return _context11.abrupt("return");

            case 38:
              throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

            case 39:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[14, 25, 29, 37], [30,, 32, 36]]);
    }))();
  } // AsyncIterable<Bytes>


  if (input[Symbol.asyncIterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12() {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, chunk;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _context12.prev = 2;
              _iterator3 = _asyncIterator(input);

            case 4:
              _context12.next = 6;
              return _awaitAsyncGenerator(_iterator3.next());

            case 6:
              _step3 = _context12.sent;
              _iteratorNormalCompletion3 = _step3.done;
              _context12.next = 10;
              return _awaitAsyncGenerator(_step3.value);

            case 10:
              _value3 = _context12.sent;

              if (_iteratorNormalCompletion3) {
                _context12.next = 18;
                break;
              }

              chunk = _value3;
              _context12.next = 15;
              return toBuffer(chunk);

            case 15:
              _iteratorNormalCompletion3 = true;
              _context12.next = 4;
              break;

            case 18:
              _context12.next = 24;
              break;

            case 20:
              _context12.prev = 20;
              _context12.t0 = _context12["catch"](2);
              _didIteratorError3 = true;
              _iteratorError3 = _context12.t0;

            case 24:
              _context12.prev = 24;
              _context12.prev = 25;

              if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
                _context12.next = 29;
                break;
              }

              _context12.next = 29;
              return _awaitAsyncGenerator(_iterator3.return());

            case 29:
              _context12.prev = 29;

              if (!_didIteratorError3) {
                _context12.next = 32;
                break;
              }

              throw _iteratorError3;

            case 32:
              return _context12.finish(29);

            case 33:
              return _context12.finish(24);

            case 34:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 20, 24, 34], [25,, 29, 33]]);
    }))();
  }

  throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');
}

function toBuffer(chunk) {
  return isBytes(chunk) ? chunk : Buffer.from(chunk);
}

function isBytes(obj) {
  return Buffer.isBuffer(obj) || ArrayBuffer.isView(obj) || obj instanceof ArrayBuffer;
}

function isBloby(obj) {
  return typeof globalThis.Blob !== 'undefined' && obj instanceof globalThis.Blob;
} // An object with a path or content property


function isFileObject(obj) {
  return typeof obj === 'object' && (obj.path || obj.content);
}

function blobToAsyncGenerator(blob) {
  if (typeof blob.stream === 'function') {
    // firefox < 69 does not support blob.stream()
    return browserStreamToIt(blob.stream());
  }

  return readBlob(blob);
}

function browserStreamToIt(_x) {
  return _browserStreamToIt.apply(this, arguments);
}

function _browserStreamToIt() {
  _browserStreamToIt = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13(stream) {
    var reader, result;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            reader = stream.getReader();

          case 1:
            if (!true) {
              _context13.next = 11;
              break;
            }

            _context13.next = 4;
            return _awaitAsyncGenerator(reader.read());

          case 4:
            result = _context13.sent;

            if (!result.done) {
              _context13.next = 7;
              break;
            }

            return _context13.abrupt("return");

          case 7:
            _context13.next = 9;
            return result.value;

          case 9:
            _context13.next = 1;
            break;

          case 11:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _browserStreamToIt.apply(this, arguments);
}

function readBlob(_x2, _x3) {
  return _readBlob.apply(this, arguments);
}

function _readBlob() {
  _readBlob = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14(blob, options) {
    var reader, chunkSize, offset, getNextChunk, data;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            options = options || {};
            reader = new globalThis.FileReader();
            chunkSize = options.chunkSize || 1024 * 1024;
            offset = options.offset || 0;

            getNextChunk = function getNextChunk() {
              return new Promise(function (resolve, reject) {
                reader.onloadend = function (e) {
                  var data = e.target.result;
                  resolve(data.byteLength === 0 ? null : data);
                };

                reader.onerror = reject;
                var end = offset + chunkSize;
                var slice = blob.slice(offset, end);
                reader.readAsArrayBuffer(slice);
                offset = end;
              });
            };

          case 5:
            if (!true) {
              _context14.next = 15;
              break;
            }

            _context14.next = 8;
            return _awaitAsyncGenerator(getNextChunk());

          case 8:
            data = _context14.sent;

            if (!(data == null)) {
              _context14.next = 11;
              break;
            }

            return _context14.abrupt("return");

          case 11:
            _context14.next = 13;
            return Buffer.from(data);

          case 13:
            _context14.next = 5;
            break;

          case 15:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _readBlob.apply(this, arguments);
}